export default (function () {
  if (typeof window === 'undefined') {
    return;
  }
  if (typeof window.navigator === 'undefined') {
    return;
  }
  return window.navigator;
});